import { reviews } from "@/mocks/members";

export default function Testimonials() {
  return (
    <section id="reviews" className="relative py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col items-start justify-between gap-4 md:mb-14 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-400">
              <i className="ri-chat-heart-line"></i>
              读者口碑
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
              50 万+ 读者的<span className="text-gradient-gold">真实好评</span>
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-400">
            从画质、更新速度到阅读体验，每一位读者的认可，都是我们持续打磨的动力。
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {reviews.map((r) => (
            <figure
              key={r.name}
              className="flex flex-col rounded-lg border border-background-600/60 bg-background-900/50 p-5 transition-colors hover:border-primary-600/50"
            >
              <div className="flex items-center gap-1 text-primary-400">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className={`text-sm ${i < r.stars ? "ri-star-fill" : "ri-star-line text-foreground-600"}`}></i>
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-300">
                「{r.text}」
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-700/60 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500/20 text-sm font-bold text-secondary-200">
                  {r.avatar}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-50">{r.name}</p>
                  <p className="text-xs text-foreground-500">{r.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}